import {
  Center,
  Flex,
  HStack,
  Separator,
  Skeleton,
  Stack,
  StackSeparator,
  VStack,
} from '@chakra-ui/react';

function Loading() {
  return (
    <>
      <Center py={4}>
        <Skeleton w={'150px'} h={'20px'} />
      </Center>
      <Separator />
      <Stack mt={2} separator={<StackSeparator />} gap={2}>
        {Array(7)
          .fill(null)
          .map((_, index) => (
            <HStack key={index} p={4} justifyContent={'space-between'}>
              <VStack alignItems={'start'}>
                <Flex gap={1} alignItems={'center'}>
                  <Skeleton w={'60px'} h={'20px'} />
                  <Skeleton w={'80px'} h={'20px'} />
                </Flex>
                <Flex gap={1} alignItems={'center'}>
                  <Skeleton w={'80px'} h={'10px'} />
                  <Skeleton w={'50px'} h={'10px'} />
                </Flex>
              </VStack>
              <Flex gap={1} alignItems={'center'}>
                <Skeleton w={'60px'} h={'10px'} />
                <Skeleton w={'10px'} h={'10px'} />
              </Flex>
            </HStack>
          ))}
      </Stack>
    </>
  );
}

export default Loading;
